import {createAction} from 'redux-actions';

export const SCREEN_CLEAN = 'SCREEN_CLEAN';
export const SCREEN_SET_INFO = 'SCREEN_SET_INFO';
export const SCREEN_LOADING = 'SCREEN_LOADING';
export const SCREEN_LOADING_MODAL = 'SCREEN_LOADING_MODAL';

export const setScreenInfo =createAction(SCREEN_SET_INFO, (options) => {
  return options
})

export const screenLoading =createAction(SCREEN_LOADING, (isLoading) => {
  return isLoading
})

export const screenLoadingModal =createAction(SCREEN_LOADING_MODAL, (isLoadingModal) => {
  return isLoadingModal
})
